import type { FpMessage, FpMessagePart } from "../../../../../schemas/codegen";
import { ToolCallPart } from "./ToolCallPart";

// Type guard for tool call parts
const isToolCallPart = (
  part: FpMessagePart,
): part is Extract<FpMessagePart, { type: "tool-call" }> =>
  part.type === "tool-call";

interface MessagePartsProps {
  message: FpMessage;
  expandedToolCalls: Set<string>;
  onToggleToolCallExpansion: (partId: string) => void;
}

export function MessageParts({
  message,
  expandedToolCalls,
  onToggleToolCallExpansion,
}: MessagePartsProps) {
  // Only show non-text parts (tool calls, etc.)
  const nonTextParts = message.parts?.filter(isToolCallPart) || [];

  if (nonTextParts.length === 0) {
    return null;
  }

  return (
    <>
      {nonTextParts.map((part) => (
        <ToolCallPart
          key={part.id}
          part={part}
          isExpanded={expandedToolCalls.has(part.id)}
          onToggleExpansion={onToggleToolCallExpansion}
        />
      ))}
    </>
  );
}
